import { Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { LOGIN_BANNER_IMG } from '../../constants/images';
import React from 'react';
import { withStyles } from 'tss-react/mui';
import LoginBannerImage from './LoginBannerImage/LoginBannerImage';
import AnimatedWaves from '../AnimatedWaves/AnimatedWaves';

const styles = theme => ({
  root: {
    minHeight: '100vh',
    width: '100%',
    maxWidth: '1920px',
    margin: '0 auto',
    fontSize: '16px',
    position: 'relative',
    backgroundColor: '#ffffff'
  },
  desktopimagewrapper: {
    position: 'relative',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'transparent',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    overflow: 'hidden'
  },
  desktopimage: {
    top: '45%',
    left: '50%',
    display: 'block',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    maxWidth: '70%'
  },
  waveimageContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '140px',
    pointerEvents: 'none',
    zIndex: 0,
    [theme.breakpoints.down('md')]: {
      height: '100px'
    }
  },
  waveimage: {
    width: '100%',
    height: '100%'
  }
});

const LoginBannerContainer = props => {
  const {
    className,
    style,
    children,
    classes,
    src,
    loginBanner,
    ready,
    onLoad,
    outsideWave,
    ContainerProps,
    ...rest
  } = props;
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <div className={className} style={{ minHeight: '100vh', ...style }} {...rest}>
      <Grid container component="main" className={classes.root}>
        {isMdUp && (
          <Grid size={{ md: 8 }} className={classes.desktopimagewrapper}>
            <img
              src={src || LOGIN_BANNER_IMG}
              className={classes.desktopimage}
              alt=""
              style={ready === false ? { visibility: 'hidden' } : undefined}
            />
          </Grid>
        )}

        <Grid size={{ xs: 12, sm: 12, md: 4 }} elevation={6} style={{ zIndex: 1 }}>
          <Grid
            container
            wrap="nowrap"
            style={{
              height: isMdUp ? '100%' : 'auto',
              minHeight: isMdUp ? 'unset' : '100vh',
              background: 'transparent'
            }}
            {...ContainerProps}
            sx={{ flexDirection: 'column' }}
          >
            <Grid style={{ width: '100%', flexGrow: isMdUp ? 1 : 0, display: 'flex', flexDirection: 'column' }}>
              <Grid
                container
                style={{
                  height: isMdUp ? '100%' : 'auto',
                  minHeight: isMdUp ? 'unset' : '100vh',
                  alignItems: 'center',
                  flexDirection: isMdUp ? 'row' : 'column',
                  justifyContent: 'center'
                }}
              >
                {loginBanner && (
                  <LoginBannerImage src={src} ready={ready !== undefined ? ready : true} onLoad={onLoad} />
                )}
                {children}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Option A & Wave: Single continuous wave spanning full width at the bottom */}
        <div className={classes.waveimageContainer}>
          <AnimatedWaves className={classes.waveimage} />
        </div>
      </Grid>
    </div>
  );
};

export default withStyles(LoginBannerContainer, styles);

